export default __webpack_public_path__ + "static/media/ic_zambia.7760f6e4.svg";